import React from 'react';

/**
 * Section heading block: eyebrow (+ optional index) · headline · lead.
 *
 * <SectionHeader
 *   index="02"                       optional, shows "02 —" before the eyebrow
 *   eyebrow="Our process"
 *   title={<>How we <em>work</em></>}  one <em> accent word per headline
 *   lead="A practical, low-risk delivery flow."
 *   align="split" | "center" | "stack"   (default "split": title left, lead right on desktop)
 *   as="h2"                          heading level (default h2)
 *   id="process-title"               for aria-labelledby on the <section>
 * />
 */
export default function SectionHeader({
  index,
  eyebrow,
  title,
  lead,
  align = 'split',
  as: Tag = 'h2',
  id,
  className = '',
}) {
  const cls = [
    'section-head',
    align === 'center' ? 'section-head--center' : '',
    align === 'stack' ? 'section-head--stack' : '',
    className,
  ].filter(Boolean).join(' ');
  return (
    <div className={cls}>
      <div>
        {eyebrow && (
          <p className="eyebrow" data-reveal>
            {index && <span className="eyebrow__num">{index}</span>}
            {eyebrow}
          </p>
        )}
        <Tag className="section-head__title h2" id={id} data-split>{title}</Tag>
      </div>
      {lead && <p className="lead" data-reveal data-delay="0.15">{lead}</p>}
    </div>
  );
}
